export const Link = ({link, text, className, children}) => {
    return (
        <a href={link} className={className} target="_blank" rel="nofollow noreferrer">{text && !children ? text : children}</a>
    )
}